import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
} from '@angular/core';
import { CustomerService } from '../customer.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerDetailDto } from 'src/app/entity/customerDetailDto';
import { LicenceTableDto } from 'src/app/entity/licenceTableDto';
import { NguCarouselConfig } from '@ngu/carousel';
import { Observable, interval, of } from 'rxjs';
import { LicenceService } from '../licence.service';
import { UserTableDto } from 'src/app/entity/userTableDto';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { User } from 'src/app/entity/user';
import { UserDetailViewComponent } from 'src/app/user/user-detail-view/user-detail-view.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerEditViewComponent } from '../customer-edit-view/customer-edit-view.component';
import { LicenceManufacturerTableDto } from 'src/app/entity/licenceManufacturerTableDto';
import { UserService } from 'src/app/user/user.service';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ManufacturerRequestDto } from 'src/app/entity/manufacturerRequestDto';
import { LicenceCarouselComponent } from './licence-carousel/licence-carousel.component';
// import { slider } from './hello-slide.animation';

@Component({
  selector: 'app-licence-detail-view',
  templateUrl: './licence-detail-view.component.html',
  styleUrls: ['./licence-detail-view.component.scss'],
  // animations: [slider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceDetailViewComponent implements OnInit {
  @Input() name: string;

  @ViewChild(LicenceCarouselComponent) carousel: LicenceCarouselComponent;
  public licences$: Observable<LicenceTableDto[]>;
  public carouselTileConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 2, md: 3, lg: 5, all: 0 },
    speed: 0,
    point: {
      visible: true,
    },
    touch: true,
    loop: false,
    interval: { timing: 1500 },
    animation: 'lazy',
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private licenceService: LicenceService,
    private userService: UserService,
    private snackbarService: SnackbarService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {}

  private customer: CustomerDetailDto;
  private activeLicence: LicenceTableDto;

  private customerId: number;
  private activeLicenceId: number;
  private loaded: boolean;

  private users: MatTableDataSource<UserTableDto>;
  private userDisplayedColumns: string[] = [
    'surname',
    'name',
    'email',
    'inactive',
    'buttons',
  ];
  private manufacturers: MatTableDataSource<LicenceManufacturerTableDto>;
  private manufacturerDisplayedColumns: string[] = [
    'manufacturerName',
    'active',
    'requestStatus',
    'request',
  ];

  @ViewChild(MatSort, { static: true }) userSort: MatSort;
  @ViewChild(MatSort, { static: true }) manufacturerSort: MatSort;
  ngOnInit(): void {
    this.users = new MatTableDataSource<UserTableDto>();
    this.manufacturers = new MatTableDataSource<LicenceManufacturerTableDto>();
    this.route.paramMap.subscribe((paramMap) => {
      this.customerId = Number(paramMap.get('customerId'));
      this.activeLicenceId = Number(paramMap.get('licenceId'));

      this.getCustomer();
      this.getUsers();
      this.getManufacturers();
    });
    this.loaded = true;
  }

  private getCustomer() {
    this.customerService
      .getCustomerDetails(this.customerId)
      .subscribe((res) => {
        this.customer = res;
        this.licences$ = this.getLicences();
      });
  }

  getLicences(): Observable<LicenceTableDto[]> {
    this.customer.licences.forEach((element) => {
      element.customerId = this.customerId;
    });
    return of(this.customer.licences);
  }

  createNewLicence() {
    this.customerService
      .getCustomerDetails(this.customerId)
      .subscribe((res) => {
        res.id = this.customerId;
        const dialogRef = this.dialog.open(CustomerEditViewComponent, {
          data: res,
        });
        dialogRef.componentInstance.moveToStep(2);
        dialogRef.afterClosed().subscribe(() => {
          this.ngOnInit();
        });
      });
  }

  createNewUser() {
    const newUser = new User();
    newUser.licenceId = this.activeLicenceId;
    const dialogRef = this.dialog.open(UserDetailViewComponent, {
      data: newUser,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getUsers();
      this.getCustomer();
      this.carousel.ngOnInit();
    });
  }

  showUserDetails(uuid: string) {
    this.userService.getUserById(uuid).subscribe(
      (res) => {
        const dialogRef = this.dialog.open(UserDetailViewComponent, {
          data: res,
        });
        dialogRef.afterClosed().subscribe(() => {
          this.getUsers();
        });
      },
      (error) => {
        this.snackbarService.open(
          'user.snackbar.errorWhileLoading',
          4,
          'failed'
        );
      }
    );
  }

  getUsers() {
    this.licenceService.getUsersByLicence(this.activeLicenceId).subscribe(
      (res) => {
        this.users.data = res;
        if (this.users !== undefined) {
          this.users.sort = this.userSort;
        }
      },
      (error) => {
        this.snackbarService.open(
          'licence.snackbar.errorWhileLoading',
          4,
          'failed'
        );
      }
    );
  }

  getManufacturers() {
    this.licenceService
      .getManufacturersByLicence(this.activeLicenceId)
      .subscribe(
        (res) => {
          this.manufacturers.data = res;

          if (this.manufacturers !== undefined) {
            this.manufacturers.sort = this.manufacturerSort;
          }
        },
        (error) => {
          this.snackbarService.open(
            'licence.snackbar.errorWhileLoading',
            4,
            'failed'
          );
        }
      );
  }

  applyUserFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.users.filter = filterValue.trim().toLowerCase();
  }

  applyManufacturerFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.manufacturers.filter = filterValue.trim().toLowerCase();
  }

  changeManufacturerActivation(row: LicenceManufacturerTableDto): void {
    row.licenceId = this.activeLicenceId;
    if (row.active) {
      this.licenceService.addLicenceManufacturer(row).subscribe(
        () => {
          this.snackbarService.open(
            'customer.licence.detail.manufacturerActivated',
            4,
            'success'
          );
          this.getManufacturers();
        },
        (error) => {
          this.snackbarService.open('shared.snackbar.saveFailed', 6, 'failed');
        }
      );
    } else {
      this.licenceService.deleteLicenceManufacturer(row).subscribe(
        () => {
          this.snackbarService.open(
            'customer.licence.detail.manufacturerDeactivated',
            4,
            'success'
          );
          this.getManufacturers();
        },
        (error) => {
          this.snackbarService.open('shared.snackbar.saveFailed', 6, 'failed');
        }
      );
    }
  }

  request(row: LicenceManufacturerTableDto): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '30%',
      data: this.translate.instant(
        'customer.licence.detail.manufacturerRequestConfirmation'
      ),
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // request

        const manufReq = new ManufacturerRequestDto();
        manufReq.customerId = this.customer.address.idUnitel;
        manufReq.manufId = row.manufacturerKuerzel;
        this.licenceService.createManufacturerRequest(manufReq).subscribe(
          () => {
            row.requestStatus = 'mrsOpen';
            this.snackbarService.open(
              'licence.detail.manufacturerRequestSent',
              4,
              'success'
            );
          },
          (error) => {
            this.snackbarService.open(
              'licence.detail.manufacturerRequestSentFailure',
              4,
              'failed'
            );
          }
        );
      }
    });
  }
}
